import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[digitalPlatformRegexFormat]',
  standalone: true,
})
export class RegexFormatDirective implements OnInit {
  private ngControl = inject(NgControl);

  @Input('digitalPlatformRegexFormat') regexString = '';

  private regex: RegExp | undefined;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.regex = new RegExp(this.regexString, 'g');
  }

  @HostListener('input', ['$event']) onInputChange(event: Event): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const value = input.value;
    this.formatValue(value);
  }

  private formatValue(value: string): void {
    if (!this.regex) {
      return;
    }

    const cleanValue = value.replace(this.regex, '');

    this.ngControl.control?.setValue(cleanValue, { emitEvent: false });
    this.el.nativeElement.value = cleanValue;
  }
}
